/**
 * Downloads a file from base64-encoded data.
 * Creates a temporary blob URL and triggers download via hidden anchor.
 * @returns true if download was initiated successfully, false on error
 */
export const downloadBase64File = (name: string, contentType: string, data64: string): boolean => {
  try {
    // Extract just the MIME type (before any semicolon with parameters)
    const mimeType = contentType.split(';')[0].trim();

    // Decode base64 to binary
    const byteCharacters = atob(data64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // Create download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    link.style.display = 'none';
    document.body.appendChild(link);

    // Trigger download with a small delay for Safari compatibility
    setTimeout(() => {
      link.click();
      document.body.removeChild(link);
      // Delay revoking URL to allow download to start
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }, 0);

    return true;
  } catch (err) {
    console.error('Failed to download file:', name, err);
    return false;
  }
};
